.text {
  color: var(--main-text-soft);
  font-size: 1.15em;
}
